import { Navigate } from 'react-router-dom'
import { usePortalContext } from '../lib/portalContext'
import { RouteLoader } from './RouteLoader'

// Landing resolver for an authenticated user. Org admins go to the org portal;
// everyone else falls through to the creator portal, whose own guards
// (RequireApproved / RequirePartner) route verification and onboarding. Checking
// org membership first avoids the creator access call (and its lazy
// PartnerAccess row) for users who are only org admins.
export function RootRedirect() {
  const { data, isLoading, error } = usePortalContext()
  if (isLoading) return <RouteLoader />
  // A failed membership check (5xx, network) means we don't know who this user
  // is — surface it via the ErrorBoundary rather than defaulting into the
  // creator portal, which reads as "you lost your org role". Not-an-admin is a
  // 403, which useOrganization resolves to { state: 'none' }, not an error.
  if (error) throw error
  if (data?.selected.kind === 'organization') return <Navigate to="/org/audio" replace />
  return <Navigate to="/dashboard" replace />
}
